import React from 'react'
import './home-css/sectionsix.css'
const SectionSix = () => {
  return (
    <div className='section-six-container'>
      <div className='section-six secSix-grid-system'>
        <div className='sec-six-text'>
            The care you need <br/>The compassion you deserve
        </div>
      </div>
      
      </div>
  )
}

export default SectionSix